export default __webpack_public_path__ + "static/media/External Link - Blue.33dd4807.svg";